import { Component, OnInit } from '@angular/core';
import { UserAccessModel } from "../shared/models/user-access.model";
import { AuthService } from "../shared/services/auth.service";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  user: UserAccessModel;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.userInfo.subscribe(userInfo => this.user = userInfo);
  }

  getSuiteLinkUrl(): string {
    const failedUrl = window.location.origin;
    return `${environment.externalUrls.mgBase}?UserId=${this.user.mercuryUsername}&Password=${this.user.mercuryPassword}&failedurl=${failedUrl}`;
  }

  hasAccessTo(key: string): boolean {
    return !!this.user?.permissions?.find(item => item.viewKey === key);
  }

}
